import {
  ALL_SCOPE_SENTINEL,
  toScope,
} from "@p0security/shared/types/assessment";
import { AnyNode } from "@p0security/shared/types/assessment/data/index";
import { FindingState } from "@p0security/shared/types/assessment/finding";
import { Typography } from "antd";
import { CommandDisplay } from "components/Integrations/CommandDisplay";
import { useContext } from "react";

import { MonitorWithFindings } from "../contexts/FindingsContext";
import { ScopeContext } from "../contexts/ScopeContext";

export const FindingsFixOrRevertCommands: React.FC<{
  nodes: AnyNode[];
  monitor: MonitorWithFindings;
  findingState: FindingState;
}> = ({ monitor, nodes, findingState }) => {
  const { integration, scopeKey } = useContext(ScopeContext);
  const fix =
    findingState === "open"
      ? monitor?.fix?.[integration]
      : monitor?.revert?.[integration];
  const scope = toScope(scopeKey);

  if (!fix || !integration || scope === ALL_SCOPE_SENTINEL) return null;

  return (
    <div>
      <Typography.Title level={3}>{monitor.label}</Typography.Title>
      <Typography.Paragraph>{fix.description}</Typography.Paragraph>
      <CommandDisplay
        commands={nodes
          .map(
            (n) =>
              fix.generate(n, { scope })?.trim() ??
              `# Finding with key ${n.key} does not have a fix available`
          )
          .join("\n\n")}
        maxRows={25}
      />
    </div>
  );
};
